<template>
  <div ref="Boyofilter"
       class="Boyo-filter">
    <el-form :inline="true"
             ref="filter"
             :model="searchInfo"
             class="demo-form-inline">
      <el-form-item v-for="item of filter.list"
                    ref="filterstwo"
                    v-show="item.flag != null?item.flag:true"
                    :key="item.label"
                    :label="item.label">
        <el-input v-if="item.type == 'text'"
                  v-model="searchInfo[item.value]"
                  clearable
                  size="small"
                  style="width:140px"
                  v-show="item.show?false:true"
                  :disabled="item.disabled">
        </el-input>
        <el-select v-else-if="item.type == 'select'"
                   v-model="searchInfo[item.value]"
                   :clearable="item.clearable?false:true"
                   :remote="item.remote"
                   :remote-method="item.remote ? remoteMethod : none"
                   @focus="item.remote ? focus(item.value) : ''"
                   @change="selectChange($event,item.label)"
                   :loading="item.loading"
                   filterable
                   size="small"
                   :style="item.style ? item.style : 'width:150px'"
                   v-show="item.show?false:true"
                   :placeholder="item.placeholder?item.placeholder:'请选择'"
                   :disabled="item.disabled?true:false">
          <el-option v-for="item in listTypeInfo[item.list]"
                     :key="item.value"
                     :label="item.label"
                     :value="item.value">
          </el-option>
        </el-select>
        <div v-else-if="item.type == 'period'">
          <el-date-picker v-model="searchInfo[item.value1]"
                          style="width:130px"
                          size="small"
                          :type="item.datetime"
                          value-format="yyyy-MM-dd"
                          placeholder="开始时间"
                          :clearable="false"
                          :disabled="item.disabled">
          </el-date-picker>
          -
          <el-date-picker v-model="searchInfo[item.value2]"
                          style="width:130px"
                          size="small"
                          :type="item.datetime"
                          value-format="yyyy-MM-dd"
                          placeholder="结束时间"
                          :clearable="false"
                          :disabled="item.disabled">
          </el-date-picker>
        </div>
        <div v-else-if="item.type == 'periodOptions'">
          <el-date-picker v-model="searchInfo[item.value1]"
                          style="width:130px"
                          size="small"
                          :type="item.datetime"
                          value-format="yyyy-MM-dd"
                          placeholder="开始时间"
                          :clearable="false"
                          :disabled="item.disabled"
                          :picker-options="pickerOptions">
          </el-date-picker>
          -
          <el-date-picker v-model="searchInfo[item.value2]"
                          style="width:130px"
                          size="small"
                          :type="item.datetime"
                          value-format="yyyy-MM-dd"
                          placeholder="结束时间"
                          :clearable="false"
                          :disabled="item.disabled">
          </el-date-picker>
        </div>
        <div v-else-if="item.type == 'period1'">
          <el-date-picker v-model="searchInfo[item.value3]"
                          style="width:190px"
                          size="small"
                          type="datetime"
                          :clearable="item.clearable?false:true"
                          value-format="yyyy-MM-dd HH:mm:ss"
                          placeholder="开始日期时间">
          </el-date-picker>
          -
          <el-date-picker v-model="searchInfo[item.value4]"
                          style="width:190px"
                          size="small"
                          type="datetime"
                          value-format="yyyy-MM-dd HH:mm:ss"
                          placeholder="结束日期时间">
          </el-date-picker>
        </div>
        <div v-else-if="item.type == 'periodMonth'">
          <el-date-picker v-model="searchInfo[item.value]"
                          style="width:130px"
                          size="small"
                          type="month"
                          value-format="yyyy-MM"
                          placeholder="选择年月"
                          :picker-options="starttime"
                          :clearable="false">
          </el-date-picker>
        </div>
        <div v-else-if="item.type == 'year'">
          <el-date-picker v-model="searchInfo[item.value]"
                          style="width:130px"
                          size="small"
                          type="year"
                          value-format="yyyy"
                          placeholder="选择年"
                          :clearable="false">
          </el-date-picker>
        </div>
        <div v-else-if="item.type == 'periodymd'">
          <el-date-picker v-model="searchInfo[item.value1]"
                          style="width:130px"
                          size="small"
                          :type="item.datetime"
                          value-format="yyyy-MM-dd"
                          placeholder="开始时间"
                          :clearable="false">
          </el-date-picker>
        </div>
      </el-form-item>
      <el-form-item>
        <span class="button button1"
              @click="handleClick('search')">
          <i class="el-icon-search">搜索</i>
        </span>
        <span class="button button2"
              @click="handleClick('refresh')">
          <i class="el-icon-refresh">重置</i>
        </span>
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
export default {
  name: 'BoyoFilter',
  props: {
    filter: Object,
    //++----------------
    result: {
      type: Object,
      default: {}
    },
    listTypeInfo: Object
  },
  data () {
    return {
      starttime: {},
      value5: '',
      searchInfo: {},
      event: '', // 配合select的远程搜索事件
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
        shortcuts: [{
          text: '今日记录',
          onClick(picker) {
            picker.$emit('pick', new Date());
          }
        },{
          text: '本月记录',
          onClick(picker) {
            const date = new Date();
            date.setTime(date.getTime() - 3600 * 1000 * 24 * Number(date.getDate() - 1));
            picker.$emit('pick', date);
          }
        }]
      }
    }
  },
  watch: {
    'filter.visible' (val) {
      let screenWidth = document.body.clientWidth
      if (screenWidth <= 960) {
        this.$refs.Boyofilter.style.display =
          this.$refs.Boyofilter.style.cssText === 'display: block;'
            ? 'none'
            : 'block'
      } else {
        // this.$refs.Boyofilter.style.display = this.$refs.Boyofilter.style.cssText === 'display: none;' ? 'block' : 'none'
      }
    },
    //++----------------
    'searchInfo': {
      deep: true,
      handler (val, old) {
        Object.assign(this.result, val)
      }
    }
  },
  mounted () {
    this.initParams()
  },
  methods: {
    initParams () {
      const obj = {}
      for (const key in this.filter.data) {
        if (this.filter.data[key]) {
          obj[key] = this.filter.data[key]
        }
      }
      this.searchInfo = obj
    },
    handleClick (val) {
      this.$emit('handleClick', val, this.searchInfo)
    },
    remoteMethod (query) {
      // console.log(query)
      if (query) {
        this.$emit('formremoteMethod', this.event, query, 'remoteMethod')
      }
    },
    none () { },
    selectChange (val,lable) {
      this.$emit('formremoteMethod', this.event, val, 'select',lable)
    },
    focus (val) {
      this.event = val
    }
  }
}
</script>
<style lang="stylus" scoped>
.heade2
  overflow hidden
.heade
  position fixed
  z-index 100
  width 100%
.test1
  display block
.test2
  display none
.button
  margin 0px
  padding 0px
  border 0px
  outline none
  padding 6px 10px
  border-radius 15px
  cursor pointer
.button1
  background #1ab3b3
  color #fff
.button1:hover
  background #19bdbd
.button1:active
  background #26a5a5
.button2
  background #ffffff
  color #333333
  border 1px solid #eeeeee
.button2:hover
  background #fbf7f7
.button2:active
  background #eceae7
</style>



// WEBPACK FOOTER //
// src/components/BoyoFilter/index.vue